export default __webpack_public_path__ + "assets/images/ed3d01ab61bdce14c22a580104845d95.png";